import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { headerTextStyles } from '../utils';

export const theme = {
  colors: {
    inmarketGreen: unifiedPlatformColorPalette.inmarketGreen,
    red: unifiedPlatformColorPalette.lightErrorDark,
    white: unifiedPlatformColorPalette.white,
    black: unifiedPlatformColorPalette.black,
    lightGray: '#CCCCCC',
    gray: '#404040',
    darkGray: '#181818',
    darkBlue: '#0F233D',
    blue: '#274C77',
  },
  charSpacing: {
    tight: -1.5,
    loose: 3,
    veryLoose: 6,
  },
  fontSizes: {
    h1: headerTextStyles.titleSlide.fontSize,
    h2: 18,
    h3: 16,
    content: 14,
  },
};
